import { Component, OnInit } from "@angular/core";
import { RestService } from "../rest.service";
import { Router } from "@angular/router";
import { catchError, retry } from "rxjs/operators";
import { FormBuilder, Validators } from "@angular/forms";
import { PasswordUtils } from "../utils/password.utils";

@Component({
  selector: "app-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.css"],
})
export class ProfileComponent implements OnInit {
  isLoading: boolean = false;
  isSuccess: boolean = false;
  isFailure: boolean = false;
  successMessage: any = "";
  failureMessage: any = "";

  userDetails: any;
  userPermission: any;
  LoginType: any = "";
  generalNotification: any = 0;
  individualNotification: any = 0;

  oldPassword: string;
  newPassword: string;
  confirmPassword: string;

  oldPasswordError: boolean;
  newPasswordError: boolean;
  confirmPasswordError: boolean;

  newPasswordPatternError: boolean;
  confirmMisMatchError: boolean;

  changePasswordForm;
  showChangePassWord: boolean;

  constructor(private _restService: RestService, private router: Router, private formBuilder: FormBuilder) {}

  ngOnInit() {
    this._restService
      .getUserProfile()
      .subscribe(
        (f: any) => (
          (this.userDetails = f.userObj),
          (this.userPermission = f.perresults),
          (this.generalNotification = this.userDetails.GeneralNotification),
          (this.individualNotification = this.userDetails.IndividualNotification),
          console.log("User Details", this.userDetails),
          console.log("Permission", this.userPermission)
        )
      );

    this.LoginType =
      localStorage.getItem("integrationType") === "1"
        ? "Okta"
        : "Active Directory";

      this.changePasswordForm = this.formBuilder.group({
        oldPassword: ["", Validators.required],
        newPassword: ["", Validators.required],
        confirmPassword: ["", Validators.required],
      });

      this.showChangePassWord = localStorage.getItem("isSuper") == "1" 
          && localStorage.getItem("LoginType") == "0";
  }



  general(e: any) {
    this.isLoading = true;
    let general: any;
    let individual = this.individualNotification;

    e.target.checked === true ? (general = 1) : (general = 0);
    this._restService
      .updateNotification(general, individual)
      .pipe(
        catchError((e) => {
          (this.isLoading = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          localStorage.setItem("general", general), (this.isLoading = false)
        )
      );
  }

  individual(e: any) {
    this.isLoading = true;
    let general = this.generalNotification;
    let individual: any;

    e.target.checked === true ? (individual = 1) : (individual = 0);
    this._restService
      .updateNotification(general, individual)
      .pipe(
        catchError((e) => {
          (this.isLoading = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          localStorage.setItem("individual", individual),
          (this.isLoading = false)
        )
      );
  }

  confirmFailureMessage() {
    this.isFailure = false;
    this.failureMessage === "Session Expired"
      ? (localStorage.clear(),
        (this.failureMessage = ""),
        this.router.navigate([""]))
      : (this.failureMessage = "");
  }

  confirmSuccessMessage() {
    this.isSuccess = false;
    this.successMessage = "";
  }

  onChangeOldPassword() {
    this.oldPasswordError = !this.oldPassword || this.oldPassword.length == 0;
  }

  onChangeNewPassword() {
    this.newPasswordError = !this.newPassword || this.newPassword.length == 0;
    this.newPasswordPatternError = !PasswordUtils.checkPasswordRules(this.newPassword);
  }

  onChangeConfirmPassword() {
    this.confirmPasswordError = !this.confirmPassword || this.confirmPassword.length == 0;
    this.confirmMisMatchError = this.confirmPassword !== this.newPassword;
  }

  changePassword() {
    this.confirmPasswordError = this.confirmPassword.length == 0;
    this.newPasswordError = !this.newPassword || this.newPassword.length == 0;
    this.oldPasswordError = !this.oldPassword || this.oldPassword.length == 0;

    if (this.confirmPasswordError || this.newPasswordError || this.oldPasswordError) {
      return;
    }

    this.confirmPasswordError = !this.confirmPassword || this.confirmPassword.length == 0;
    this.newPasswordPatternError = !PasswordUtils.checkPasswordRules(this.newPassword);
    this.confirmMisMatchError = this.confirmPassword !== this.newPassword;
    
    if (this.newPasswordPatternError || this.confirmMisMatchError) {
      return;
    }

    this.isLoading = true;
    this._restService
        .changePassword(PasswordUtils.encryptPassword(this.oldPassword), PasswordUtils.encryptPassword(this.newPassword))
        .pipe(
          catchError((e) => {
            console.log(e)
            this.isLoading = false;
            this.isFailure = true;
            this.failureMessage = (e && e.message) || "Failed to update password. Please try again"
            return e;
          })
        )
        .subscribe( (res: any) => {
          this.isLoading = false;
          
          if (res && res.status === "Success") {
            this.isSuccess = true;
            this.successMessage = res.message;
          } else {
            this.isFailure = true;
            this.failureMessage = res.message || "Failed to update password. Please try again"
          }

        });
  }
}
